import { Model } from '@/models/Model'
import Property from '@/decorators/Property'

export class Customer extends Model {
	protected jsonApiType = 'accounting/customers'
	protected static pageSize = 10

	@Property()
	public name!: string

	@Property()
	public email!: string

	@Property()
	public reference!: string | null

	@Property()
	public vatNumber!: string | null

	@Property()
	public relationTypes!: Array<string>

	@Property()
	public paymentTermDays!: number | null

	public get search() {
		return [this.name, this.reference ? `(${this.reference})` : null].filter(Boolean).join(' ')
	}

	public static async fetchLazy(id): Promise<Customer> {
		const store = (await import('@/store/index')).store
		if (!store.getters['accountingCustomers/hasCached'](id)) {
			await store.dispatch('accountingCustomers/findRecord', id)
		}

		return store.getters['accountingCustomers/peekRecord'](id)
	}
}
